import {createContext, useContext, useEffect, useState} from "react";
import axios from "axios";
import useCookie from "react-use-cookie";
import {enc, AES} from 'crypto-js';

const secretKey = "cromptonssecretkey";
const userAuthContext = createContext();

const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

//const CROMPTON_URL = "https://iot.crompton.co.in:8443/LAPI/"

//const CROMPTON_URL = "https://iot.crompton.co.in:8443/ZAPI/"

export function UserAuthContextProvider({children}) {
    const [user, setUser] = useState({});
    const [userstate, setuserstate] = useState(false);
    const [error, setError] = useState("");
    const [statuscode, setstatuscode] = useState("");
    const [tokenfromapi, settokenfromapi] = useState("");
    const [message, setmessage] = useState("");
    const [userToken, setUserToken] = useCookie('id', '0');
    const [Token, setToken] = useCookie('token-senze', '0')
    const [Username, setUsername] = useCookie('username-senze', '0')
    const [accesscontrollevel, setaccesscontrollevel] = useCookie('acl', 'k');
    const [admin, setAdmin] = useCookie('admin', '0');
    const version = require('../../package.json').version;

    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === "auth:event") {
                const data = JSON.parse(event.newValue || "{}");
                if (data.type === "LOGOUT") {
                    window.location.href = "/senze-3.0";
                }
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    function logIn(emailphone, password) {
        var bodyFormData;
        let index = emailphone.indexOf("@");

        if (index === -1) {
            bodyFormData = {
                mobileNumber: emailphone,
                password: password
            }
        } else {
            bodyFormData = {
                email: emailphone,
                password: password
            }
        }

        //console.log(CROMPTON_URL)
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/signIn',
            data: bodyFormData
        }).then(response => {
            //console.log(response)
            setUser(response.data.userId)
            setuserstate(true);
            setUserToken('1', {
                Secure: true,
                SameSite: 'Strict',
            });
            setaccesscontrollevel(response.data.acl, {
                Secure: true,
                SameSite: 'Strict'
            })
            //setadmin(response.data.admin)
            setstatuscode(response.data.status)
            const encryptedValue = AES.encrypt(response.data.token, secretKey).toString();
            setToken(encryptedValue, {
                Secure: true,
                SameSite: 'Strict',
            })
            const encryptedValueusername = AES.encrypt(response.data.username, secretKey).toString();
            setUsername(encryptedValueusername, {
                Secure: true,
                SameSite: 'Strict',
            })
            settokenfromapi(response.data.token)
            // <Navigate to="/dashboard" />;
            return response;
            window.localStorage.setItem("token", tokenfromapi)

        })
            .catch(
                error => {
                    //console.log(error)
                    return error
                }
            )
    }

    /**
     * ARJUN: 21/05/2025:  Login V2 method with password and email code or mobile code along with email or mobile number
     * @param emailphone
     * @param password
     * @param code
     * @returns {Promise<axios.AxiosResponse<any>>}
     */
    function logInV2(emailphone, password, code) {
        var bodyFormData;
        let index = emailphone.indexOf("@");

        if (index === -1) {
            bodyFormData = {
                mobileNumber: emailphone,
                password: password,
                mobileCode: code
            }
        } else {
            bodyFormData = {
                email: emailphone,
                password: password,
                emailCode: code
            }
        }

        //console.log(CROMPTON_URL)
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/V2/signIn',
            data: bodyFormData
        }).then(response => {
            //console.log(response)
            setUser(response.data.userId)
            setuserstate(true);
            setUserToken('1', {
                Secure: true,
                SameSite: 'Strict',
            });
            setaccesscontrollevel(response.data.acl, {
                Secure: true,
                SameSite: 'Strict'
            })
            setAdmin(response.data.admin)
            setstatuscode(response.data.status)
            const encryptedValue = AES.encrypt(response.data.token, secretKey).toString();
            setToken(encryptedValue, {
                Secure: true,
                SameSite: 'Strict',
            })
            const encryptedValueusername = AES.encrypt(response.data.username, secretKey).toString();
            setUsername(encryptedValueusername, {
                Secure: true,
                SameSite: 'Strict',
            })
            settokenfromapi(response.data.token)

            postEntityVersionDetails(response.data.username, response.data.token)
            // <Navigate to="/dashboard" />;
            return response;
            window.localStorage.setItem("token", tokenfromapi)

        })
            .catch(
                error => {
                    //console.log(error)
                    return error
                }
            )
    }

    function logOut() {
        const uname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
        const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
        axios({
            method: 'get',
            url: CROMPTON_URL + 'user/signOut/' + uname,

            headers: {
                Authorization: decryptedValue,
            }

        }).then(response => {
//console.log(response)
        })
            .catch(
                error => {

                }
            )
        setUser("");
        setmessage("")
        setToken('0');
        //window.localStorage.removeItem("token")
        settokenfromapi("")
        setuserstate(false)
        setUserToken('0')
        setUsername("0")
        setaccesscontrollevel("k")

        // notify other tabs
        localStorage.setItem("auth:event", JSON.stringify({
            type: "LOGOUT",
            time: Date.now()
        }));

        // optional: redirect
        window.location.href = "/senze-3.0";
    }

    /**
     *
     * @param mobileNumber
     * @returns {Promise<unknown>}
     */
    function getMobileOtp(mobileNumber) {
        var bodyFormData = {
            mobileNumber: mobileNumber
        };

        return axios({
            method: 'post',
            url: CROMPTON_URL + 'account/getMobileOtp',
            data: bodyFormData
        }).then(response => {
            setstatuscode(response.status)
            return response;
            //console.log(statuscode)
        }).catch(
            error => {
                //console.log(error.response.data.message)
                setmessage(error.response.data.message)
                setError(error)
                return error
            }
        )
    }

    /**
     *
     * @param email
     * @returns {Promise<unknown>}
     */
    function getEmailOtp(email) {
        var bodyFormData = {
            email: email
        };

        return axios({
            method: 'post',
            url: CROMPTON_URL + 'account/getEmailOtp',
            data: bodyFormData
        }).then(response => {
            setstatuscode(response.status)
            return response;
            //console.log(statuscode)
        })
            .catch(
                error => {
                    //console.log(error.response.data.message)
                    setmessage(error.response.data.message)
                    setstatuscode(error.response.status)
                    return error
                    //setError(error)
                }
            )

    }

    /**
     *
     * @param email
     * @param otp
     * @returns {Promise<unknown>}
     */
    function verifyEmailOtp(email, otp) {
        var bodyFormData = {
            email: email,
            otp: otp
        };

        //console.log(bodyFormData)

        return axios({
            method: 'post',
            url: CROMPTON_URL + 'account/verifyEmailOtp',
            data: bodyFormData
        }).then(response => {
            //console.log(response)
            return response
        })
            .catch(
                error => {
                    //console.log(error)
                    setmessage(error.response.data.message)
                    setstatuscode(error.response.status)
                    //setError(error)
                    return error
                }
            )
    }

    /**
     *
     * @param mobileNumber
     * @param otp
     * @returns {Promise<unknown>}
     */
    function verifyMobileOtp(mobileNumber, otp) {
        var bodyFormData = {
            mobile: mobileNumber,
            otp: otp
        };

        //console.log(bodyFormData)

        return axios({
            method: 'post',
            url: CROMPTON_URL + 'account/verifyMobileOtp',
            data: bodyFormData
        }).then(response => {
            return response
        })
            .catch(
                error => {
                    //console.log(error)
                    setmessage(error.response.data.message)
                    setError(error)
                    return error
                }
            )
    }

    /**
     *
     * @param email
     * @param otp
     * @param password
     * @returns {Promise<unknown>}
     */
    function resetPassword(email, password, otp) {
        var bodyFormData;
        let index = email.indexOf("@");

        if (index === -1) {
            bodyFormData = {
                mobile: email,
                password: password,
                mobileCode: otp
            }
        } else {
            bodyFormData = {
                email: email,
                password: password,
                emailCode: otp
            }
        }

        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/v2/resetPassword',
            data: bodyFormData
        }).then(response => {
            // notify other tabs
            localStorage.setItem("auth:event", JSON.stringify({
                type: "LOGOUT",
                time: Date.now()
            }));

            // optional: redirect
            window.location.href = "/senze-3.0";

            return response
            //console.log(response.data.message)
        })
            .catch(
                error => {
                    //console.log(error)
                    setmessage(error.response.data.message)
                    setError(error)
                    return error
                }
            )
    }

    /**
     *
     * @param email
     * @param password
     * @param otp
     * @returns {Promise<unknown>}
     */
    function createAccount(email, password) {
        var bodyFormData;
        let index = email.indexOf("@");

        //console.log("INSIDE")

        if (index === -1) {
            bodyFormData = {
                mobileNumber: email,
                password: password,
                admin: 1
            }
        } else {
            bodyFormData = {
                email: email,
                password: password,
                admin: 1
            }
        }

        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/register',
            data: bodyFormData
        }).then(response => {
            //console.log(response)
            setUser(response.data.userId)
            setuserstate(true);
            setUserToken('1', {
                Secure: true,
                SameSite: 'Strict',
            });
            setaccesscontrollevel(response.data.acl, {
                Secure: true,
                SameSite: 'Strict'
            })
            //setadmin(response.data.admin)
            setstatuscode(response.data.status)
            const encryptedValue = AES.encrypt(response.data.token, secretKey).toString();
            setToken(encryptedValue, {
                Secure: true,
                SameSite: 'Strict',
            })
            const encryptedValueusername = AES.encrypt(response.data.username, secretKey).toString();
            setUsername(encryptedValueusername, {
                Secure: true,
                SameSite: 'Strict',
            })
            settokenfromapi(response.data.token)
            // <Navigate to="/dashboard" />;
            return response;
            window.localStorage.setItem("token", tokenfromapi)
        })
            .catch(
                error => {
                    //console.log(error)
                    setmessage(error.response.data.message)
                    setError(error)
                    return error
                }
            )
    }

    function checkPasswords(password, confirmPassword) {

        if (password !== confirmPassword) {
            setmessage("The passwords do not match. Please try again.")
            //alert("The passwords do not match. Please try again.");
            return false;
        }

        return true;
    }

    /**
     * Validating user Password
     * password
     * returns: true/false
     */

    /*   ^               # start-of-string
       (?=.*[0-9])       # a digit must occur at least once
       (?=.*[a-z])       # a lower case letter must occur at least once
       (?=.*[A-Z])       # an upper case letter must occur at least once
       (?=.*[@#$%^&+=])  # a special character must occur at least once you can replace with your special characters
       (?=\\S+$)          # no whitespace allowed in the entire string
       .{4,}             # anything, at least six places though
       $                 # end-of-string*/
    function isValidPassword(password) {
        // Regex to check valid password.
        //const regex = "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=?!_])(?=\\S+$).{8,24}$";
        const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/;

        //console.log(String(password).match(passwordRegex))
        // Return if the password matched the ReGex
        return String(password).match(passwordRegex)
    }

    /**
     * Validating user phone number
     * phone number
     * returns: true/false
     */
    function isValidMobileNumber(mobileNumber) {
        const regex = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
        //return !!mobileNumber.value.match(mobileNumber, regex);
        return String(mobileNumber).toLowerCase().match(regex)

    }

    /**
     * Validating user email address
     * email address
     * returns: true/false
     */
    function isValidEmailAddress(email) {
        const regex = "^([_a-zA-Z0-9-]+(\\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*(\\.[a-zA-Z]{1,6}))?$";
        //return !!email.value.match(email, regex);

        return String(email).toLowerCase().match(regex)
    }

    /**
     * ARJUN: 12/06/2024: Delete account API method
     */

    function deleteAccount(email, otp) {
        var bodyFormData;
        let index = email.indexOf("@");

        if (index === -1) {
            bodyFormData = {
                mobile: email,
                mobileCode: otp,
            }
        } else {
            bodyFormData = {
                email: email,
                emailCode: otp
            }
        }

        return axios({
            method: 'delete',
            url: CROMPTON_URL + 'user/V2/delete',
            data: bodyFormData
        }).then(response => {
            return response;
        })
            .catch(
                error => {
                    //console.log(error)
                    setmessage(error.response.data.message)
                    setError(error)
                    return error
                }
            )
    }

    /**
     * ARJUN: 23/05/2024: Added a new function to sign in to SENZE account using OTP
     */

    function loginUsingOtp(email, receivedOtp) {
        var bodyFormData;
        let index = email.indexOf("@");

        if (index === -1) {
            bodyFormData = {
                mobileNumber: email,
                otp: receivedOtp
            }

            //console.log(bodyFormData)

            return axios({
                method: 'post',
                url: CROMPTON_URL + 'user/signInMobile',
                data: bodyFormData
            }).then(response => {
                // console.log(response)
                setuserstate(true);
                setUserToken('1', {
                    Secure: true,
                    SameSite: 'Strict',
                });
                setaccesscontrollevel(response.data.acl, {
                    Secure: true,
                    SameSite: 'Strict'
                })
                //setadmin(response.data.admin)
                setstatuscode(response.data.status)
                const encryptedValue = AES.encrypt(response.data.token, secretKey).toString();
                setToken(encryptedValue, {
                    Secure: true,
                    SameSite: 'Strict',
                })
                const encryptedValueusername = AES.encrypt(response.data.username, secretKey).toString();
                setUsername(encryptedValueusername, {
                    Secure: true,
                    SameSite: 'Strict',
                })
                settokenfromapi(response.data.token)
                return response
                //console.log(response.data.message)
            })
                .catch(
                    error => {
                        //console.log(error)
                        setmessage(error.response.data.message)
                        setError(error)
                        return error
                    }
                )


        } else {
            bodyFormData = {
                email: email,
                otp: receivedOtp
            }

            // console.log(bodyFormData)

            return axios({
                method: 'post',
                url: CROMPTON_URL + 'user/signInEmail',
                data: bodyFormData
            }).then(response => {
                // console.log(response)
                setuserstate(true);
                setUserToken('1', {
                    Secure: true,
                    SameSite: 'Strict',
                });
                setaccesscontrollevel(response.data.acl, {
                    Secure: true,
                    SameSite: 'Strict'
                })
                //setadmin(response.data.admin)
                setstatuscode(response.data.status)
                const encryptedValue = AES.encrypt(response.data.token, secretKey).toString();
                setToken(encryptedValue, {
                    Secure: true,
                    SameSite: 'Strict',
                })
                const encryptedValueusername = AES.encrypt(response.data.username, secretKey).toString();
                setUsername(encryptedValueusername, {
                    Secure: true,
                    SameSite: 'Strict',
                })
                settokenfromapi(response.data.token)
                return response
                //console.log(response.data.message)
            })
                .catch(
                    error => {
                        //console.log(error)
                        setmessage(error.response.data.message)
                        setError(error)
                        return error
                    }
                )
        }

    }

    /**
     * ARJUN: 12/06/2024: Delete account API method
     */

    function postEntityVersionDetails(username, token) {
        var bodyFormData;
        bodyFormData = {
            username: username,
            entity: "WEB",
            version: version
        }


        return axios({
            method: 'post',
            url: CROMPTON_URL + 'app/save/entity',
            data: bodyFormData,
            headers: {
                Authorization: token,
            },
        }).then(response => {
            return response;
        })
            .catch(
                error => {
                    //console.log(error)
                    setmessage(error.response.data.message)
                    setError(error)
                    return error
                }
            )
    }

    useEffect(() => {
        const unsubscribe = (currentuser) => {
            // //console.log(window.localStorage.getItem("token"))
            if (window.localStorage.getItem("token")) {
                setuserstate(true)
                // setUserToken('1')
            }
            //ReactSession.set("token", response.data.token);
            //const token=window.localStorage("token")
            //console.log("in useeffect")
            // if(!token&&statuscode==200){
            //  window.localStorage.setItem("token",tokenfromapi)
            //  }
            setUser(currentuser);
        };

        return () => {
            unsubscribe();
        };
    }, []);


    return (
        <userAuthContext.Provider
            value={{
                user,
                Token,
                userToken,
                Username,
                userstate,
                message,
                statuscode,
                tokenfromapi,
                error,
                accesscontrollevel,
                logIn,
                logInV2,
                getEmailOtp,
                getMobileOtp,
                verifyMobileOtp,
                verifyEmailOtp,
                resetPassword,
                logOut,
                deleteAccount,
                loginUsingOtp,
                checkPasswords,
                isValidMobileNumber,
                isValidEmailAddress,
                createAccount,
                isValidPassword
            }}
        >
            {children}
        </userAuthContext.Provider>
    );
}

export function useUserAuth() {
    return useContext(userAuthContext);
}
